import NabDafInMemoryCacheStrategy from './nab-daf-in-memory';

const tokenCacheStrategy = new NabDafInMemoryCacheStrategy();

export const getTokenCacheStrategy = () => {
	return {
		authTokenCacheStrategy: tokenCacheStrategy,
	};
};
